export default __webpack_public_path__ + "static/media/category5.2a832144.png";